import { usePunditUserContext } from "@/react/contexts";

export const useIsPropertiesPanelRevampEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.cms_builder_ui_properties_panel_revamp_enabled,
  );
};
